@if (label) {
  <label class="form-label">{{ label }}</label>
}
<div class="input-icon">
  <input type="text"
    value=""
    class="form-control"
    [formControl]="searchTermControl"
    [placeholder]="placeholder ? ((placeholder | translate) | titlecase) : null" />
    <span class="input-icon-addon">
      <i class="fa-regular fa-magnifying-glass"></i>
    </span>
  </div>
